angular.module('TetherApp').factory('sweepstakesPrizingTemplateService',
    [
        '$location',
        'templateService',
        function ($location, templateService) {

            let title = ($location.absUrl().indexOf('create') > -1) ? 'Create' : 'Edit';

            let form = {
                title: title + ' Prize Pool',
                divs: [
                    {
                        templateUrl: templateService.getTemplateUrl('sweepstakesPrizePoolName'),
                        attributes: {
                            name: 'name',
                            class: 'form-control',
                            placeholder: 'Name',
                            label: {
                                for: 'name',
                                class: 'form-control',
                                value: 'Name'
                            }
                        }
                    },
                    {
                        templateUrl: templateService.getTemplateUrl('sweepstakesSelect'),
                        attributes: {
                            name: 'class',
                            class: 'form-control',
                            label: {
                                for: 'class',
                                class: 'form-control',
                                value: 'Class'
                            },
                            options: [
                                {
                                    text: 'Physical Prize',
                                    value: '\\Sweepstakes\\Prize\\Validators\\PhysicalPrizeValidator'
                                },
                                {
                                    text: 'E-Prize',
                                    value: '\\Sweepstakes\\Prize\\Validators\\EPrizeValidator'
                                }
                            ],
                            selectedValue: {
                                text: 'Physical Prize',
                                value: '\\Sweepstakes\\Prize\\Validators\\PhysicalPrizeValidator'
                            }
                        }
                    },
                    {
                        templateUrl: templateService.getTemplateUrl('sweepstakesText'),
                        attributes: {
                            name: 'js_hook',
                            class: 'form-control',
                            placeholder: 'JS Hook',
                            label: {
                                for: 'js_hook',
                                class: 'form-control',
                                value: 'JS Hook'
                            }
                        }
                    },
                    {
                        templateUrl: templateService.getTemplateUrl('sweepstakesTextarea'),
                        attributes: {
                            name: 'winner_page_html',
                            class: 'form-control',
                            placeholder: 'Winner Page HTML',
                            label: {
                                for: 'winner_page_html',
                                class: 'form-control',
                                value: 'Winner Page HTML'
                            }
                        }
                    },
                    {
                        templateUrl: templateService.getTemplateUrl('sweepstakesTextarea'),
                        attributes: {
                            name: 'winner_page_html_fr',
                            class: 'form-control',
                            placeholder: 'Winner Page HTML FR',
                            label: {
                                for: 'winner_page_html_fr',
                                class: 'form-control',
                                value: 'Winner Page HTML FR'
                            }
                        }
                    },
                    {
                        templateUrl: templateService.getTemplateUrl('sweepstakesText'),
                        attributes: {
                            name: 'winner_email_title',
                            class: 'form-control',
                            placeholder: 'Winner Email Title',
                            label: {
                                for: 'winner_email_title',
                                class: 'form-control',
                                value: 'Winner Email Title'
                            }
                        }
                    },
                    {
                        templateUrl: templateService.getTemplateUrl('sweepstakesTextarea'),
                        attributes: {
                            name: 'winner_email_html',
                            class: 'form-control',
                            placeholder: 'Winner Email HTML',
                            label: {
                                for: 'winner_email_html',
                                class: 'form-control',
                                value: 'Winner Email HTML'
                            }
                        }
                    },
                    {
                        templateUrl: templateService.getTemplateUrl('sweepstakesText'),
                        attributes: {
                            name: 'winner_email_title_fr',
                            class: 'form-control',
                            placeholder: 'Winner Email Title FR',
                            label: {
                                for: 'winner_email_title_fr',
                                class: 'form-control',
                                value: 'Winner Email Title FR'
                            }
                        }
                    },
                    {
                        templateUrl: templateService.getTemplateUrl('sweepstakesTextarea'),
                        attributes: {
                            name: 'winner_email_html_fr',
                            class: 'form-control',
                            placeholder: 'Winner Email HTML FR',
                            label: {
                                for: 'winner_email_html_fr',
                                class: 'form-control',
                                value: 'Winner Email HTML FR'
                            }
                        }
                    }
                ]
            };

            return {
                form: form
            }

        }
    ]
);
